import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineCardMembership } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";

const SocialSecurityCertificate = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const TRANSLATION = t("SUBSCRIPTION_AMELLIS.PROOF", {
    returnObjects: true,
  });
  const BLOCK = get(TRANSLATION, "SOCIAL_SECURITY_CERTIFICATE");

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={BLOCK.TITLE} subtitle={BLOCK.SUBTITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={BLOCK.FORM.ADHERENT}
                icon={<MdOutlineCardMembership size={16} />}
                optional={TRANSLATION.OPTIONAL}
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                multiple
                onUpload={(fileList) => {
                  setFieldValue("proof.socialSecurityCertificate", fileList);
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      socialSecurityCertificate: fileList,
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.socialSecurityCertificate", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {TRANSLATION.ACTIONS.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SocialSecurityCertificate;
